<template>
  <BaseModal
    :id="`${$options.name}-${instanceId}`"
    class="cookie-popup"
    data-module="cookie-popup"
    :show-on-desk="showOnDesk"
    :show-on-mobile="showOnMobile"
    :style="{
      zIndex,
      '--primary-color': primaryColor,
      '--background-color': backgroundColor,
      '--text-color': textColor,
    }"
  >
    <div class="cookie-popup__content">
      <div
        class="cookie-popup__content__text"
        v-html="text"
      ></div>
      <div class="cookie-popup__content__buttons">
        <EditorLink
          v-show="hasLink"
          class="cta vazado"
          :model="linkUrl"
        >
          {{ linkLabel }}
        </EditorLink>
        <button class="cta">
          {{ $t('acceptButton') }}
        </button>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '../generic/modals/BaseModal.vue';
import EditorLink from '../EditorLink.vue';

const tinycolor = require('tinycolor2');

export default {
  name: 'CookiePopup',
  components: {
    BaseModal,
    EditorLink,
  },
  inheritAttrs: false,
  props: {
    ...BaseModal.props,
    instanceId: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '#FCFCFC',
    },
    primaryColor: {
      type: String,
      default: '#3E9AA6',
    },
    hasLink: {
      type: Boolean,
      default: false,
    },
    linkLabel: {
      type: String,
      default: '',
    },
    linkUrl: {
      type: Object,
      default: () => ({
        type: 'externalLink',
        value: '',
        openInNewTab: true,
      }),
    },
  },
  computed: {
    textColor() {
      if (!this.backgroundColor) {
        return null;
      }
      return tinycolor(this.backgroundColor).isDark() ? '#FFFFFF' : '#000000';
    },
  },
  metadata: {
    extends: BaseModal.metadata,
    tabs: [
      {
        name: 'content',
        groups: [
          {
            name: 'text',
            label: 'Texto',
            fields: [
              {
                name: 'text',
                label: 'Texto do pop-up',
                type: 'Html',
              },
            ],
          },
          {
            name: 'config',
            label: 'Configurações',
            fields: [
              {
                name: 'hasLink',
                label: 'Inserir link para página de políticas',
                type: 'Checkbox',
              },
              {
                name: 'linkLabel',
                label: 'Texto do link',
                type: 'ShortText',
                isEnabled({ hasLink }) {
                  return hasLink;
                },
              },
              {
                name: 'linkUrl',
                label: 'URL do link',
                type: 'Url',
                isEnabled({ hasLink }) {
                  return hasLink;
                },
              },
            ],
          },
        ],
      },
      {
        name: 'appearance',
        label: 'Aparência',
        groups: [
          {
            name: 'colors',
            label: 'Cores',
            fields: [
              {
                name: 'backgroundColor',
                type: 'ColorPicker',
                label: 'Cor de fundo',
              },
              {
                name: 'primaryColor',
                type: 'ColorPicker',
                label: 'Cor primária',
              },
            ],
          },
        ],
      },
    ],
  },
  i18n: {
    messages: {
      pt: {
        acceptButton: 'Aceitar',
      },
      en: {
        acceptButton: 'Accept',
      },
      es: {
        acceptButton: 'Aceptar',
      },
    },
  },
};
</script>

<style scoped lang="scss">
.cookie-popup {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: var(--background-color, $lb-ice);
  box-shadow: 0px 0.36px 10.8px rgba($lb-black, 0.07);
  padding: 16px;

  &__content {
    max-width: 1170px;
    margin: auto;

    @include media-breakpoint-up(sm) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__text {
      color: var(--text-color, $lb-dark-gray);
      font-size: $size-small;
      line-height: 1.4;
      opacity: 0.6;

      @include media-breakpoint-down(sm) {
        margin-bottom: 15px;
      }

      @include media-breakpoint-up(sm) {
        margin-right: 15px;
      }
    }

    &__buttons {
      @include media-breakpoint-up(sm) {
        margin: 0 -6px;
        display: flex;
      }

      .cta {
        min-width: 97px;
        text-align: center;
        padding: 5px 0;
        min-height: unset;
        text-transform: unset;
        font-weight: normal;

        @include media-breakpoint-down(sm) {
          width: 100%;
        }

        @include media-breakpoint-up(sm) {
          margin: 0 6px;
        }

        &:not(.vazado) {
          color: $lb-white;
          background-color: var(--primary-color, $crm-blue-primary);
        }

        &.vazado {
          color: var(--primary-color, $crm-blue-primary);

          @include media-breakpoint-down(sm) {
            margin-bottom: 15px;
          }
        }
      }
    }
  }
}
</style>
